// Utilitaires pour la gestion des couleurs des chantiers

// Palette de couleurs distinctes et agréables
const COLOR_PALETTE = [
  { bg: 'bg-blue-400', border: 'border-blue-500', text: 'text-blue-900', hex: '#60A5FA' },
  { bg: 'bg-green-400', border: 'border-green-500', text: 'text-green-900', hex: '#4ADE80' },
  { bg: 'bg-purple-400', border: 'border-purple-500', text: 'text-purple-900', hex: '#A78BFA' },
  { bg: 'bg-orange-400', border: 'border-orange-500', text: 'text-orange-900', hex: '#FB923C' },
  { bg: 'bg-pink-400', border: 'border-pink-500', text: 'text-pink-900', hex: '#F472B6' },
  { bg: 'bg-indigo-400', border: 'border-indigo-500', text: 'text-indigo-900', hex: '#818CF8' },
  { bg: 'bg-teal-400', border: 'border-teal-500', text: 'text-teal-900', hex: '#2DD4BF' },
  { bg: 'bg-red-400', border: 'border-red-500', text: 'text-red-900', hex: '#F87171' },
  { bg: 'bg-yellow-400', border: 'border-yellow-500', text: 'text-yellow-900', hex: '#FACC15' },
  { bg: 'bg-cyan-400', border: 'border-cyan-500', text: 'text-cyan-900', hex: '#22D3EE' },
  { bg: 'bg-emerald-400', border: 'border-emerald-500', text: 'text-emerald-900', hex: '#34D399' },
  { bg: 'bg-violet-400', border: 'border-violet-500', text: 'text-violet-900', hex: '#8B5CF6' }
];

// Cache pour les couleurs assignées aux projets
const projectColors = new Map();

// Fonction pour obtenir une couleur unique pour un projet
export const getProjectColor = (projectId) => {
  if (!projectColors.has(projectId)) {
    const usedIndices = new Set(projectColors.values());
    let colorIndex = 0;
    
    // Trouver le premier index de couleur non utilisé
    while (usedIndices.has(colorIndex) && colorIndex < COLOR_PALETTE.length) {
      colorIndex++;
    }
    
    // Si toutes les couleurs sont utilisées, on recommence
    if (colorIndex >= COLOR_PALETTE.length) {
      colorIndex = projectColors.size % COLOR_PALETTE.length;
    }
    
    projectColors.set(projectId, colorIndex);
  }
  
  return COLOR_PALETTE[projectColors.get(projectId)];
};

// Fonction pour obtenir la couleur par statut (pour les projets terminés, etc.)
export const getStatusColor = (status) => {
  const colors = {
    planned: { bg: 'bg-blue-400', border: 'border-blue-500', text: 'text-blue-900' },
    'in-progress': { bg: 'bg-green-400', border: 'border-green-500', text: 'text-green-900' },
    completed: { bg: 'bg-gray-400', border: 'border-gray-500', text: 'text-gray-900' }
  };
  return colors[status] || colors.planned;
};

// Fonction pour réinitialiser les couleurs (utile lors du rechargement)
export const resetProjectColors = () => {
  projectColors.clear();
};

// Fonction pour obtenir toutes les couleurs assignées (pour légende)
export const getAllAssignedColors = (projects) => {
  return projects.map(project => ({
    projectId: project.id,
    projectName: project.name,
    color: getProjectColor(project.id)
  }));
};

// Fonction pour générer une couleur aléatoire si palette épuisée
export const generateRandomColor = () => {
  const hue = Math.floor(Math.random() * 360);
  return {
    bg: `bg-[hsl(${hue},70%,60%)]`,
    border: `border-[hsl(${hue},70%,50%)]`,
    text: `text-[hsl(${hue},70%,20%)]`,
    hex: `hsl(${hue}, 70%, 60%)`
  };
};